import * as yup from 'yup';

import { constants } from 'utils';

const KIOSK_CODE_REGEX = /\d{8}/;

export const schema = yup.object().shape({
  kioskCode: yup
    .string()
    .required(constants.GenericValidationErrors.required)
    .test('validCode', constants.GenericValidationErrors.invalidSecurityOrKioskCode, kioskCode => {
      return KIOSK_CODE_REGEX.test(kioskCode);
    })
});
